<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <PublicLayout v-if="$route.name === 'publicLayout'" />
    <VerticalLayout v-else />
  </div>
</template>

<script>
import VerticalLayout from "./layouts/VerticalLayout/VerticalLayout.vue";
import PublicLayout from "./layouts/PublicLayout/PublicLayout.vue";
export default {
  name: "App",
  components: {
    VerticalLayout,
    PublicLayout
  },
  created() {
    console.log(this.$route)
  }
};
</script>

<style>
  .vgt-table {
    margin-bottom: 0px !important;
  }
</style>
